export default __webpack_public_path__ + "647ba9b.svg";